import React from 'react'
import Radium from 'radium'
import { connect } from 'cerebral-view-react'
import { t } from '@billes/translator-client'
import styles from './styles'

const Menu = ({
  currentModules,
  listUserHeaderAccessMenuOpen,
  listModule,
  signals
}) => {
  if (!listUserHeaderAccessMenuOpen) {
    return null
  }
  return (
    <div tabIndex={1} style={styles.container}>
      {currentModules.map(module => {
        if (module.module === listModule) return null
        return (
          <div
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              signals.app.selectListModule({ module: module.module })
            }}
            key={module.module}
            style={styles.item}>
            {t(`modules.${module.module}.name`)}
          </div>
        )
      })}
    </div>
  )
}

export default connect({
  currentModules: 'client.user.currentClient.modules',
  listUserHeaderAccessMenuOpen: 'app.listUserHeaderAccessMenuOpen',
  listModule: 'app.listModule'
})(Radium(Menu))



// WEBPACK FOOTER //
// ./src/components/User/list/header/menu/menu.js